import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import EditDataStoreItemModal from '@modals/EditDataStoreItemModal'

import type { DataStoreItemModel } from '@models/types'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PageContent from './components/PageContent'

const defaultState = {
  showEditDataStoreItemModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    EditDataStoreItemModal: {
      closeModal: () => setState({ showEditDataStoreItemModal: false }),
      createActivity: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateDataStoreItem: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showEditDataStoreItemModal } = state

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      createActivity: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      showEditDataStoreItemModal: (payload: { dataStoreItem: DataStoreItemModel }) => {
        setModalData('EditDataStoreItemModal', payload)
        setState({ showEditDataStoreItemModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <EditDataStoreItemModal
          callbacks={callbacks('EditDataStoreItemModal', setState)}
          showModal={showEditDataStoreItemModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
